import React from 'react';
import PromptClick from '../PromptClick';
import CircleIcon from '../CircleIcon';
import { ReactComponent as Close } from '../../assets/close-big.svg';

const DeleteRenderer = ({ onDelete }) => (
  <PromptClick onClick={onDelete} body="areYouSureYouWantToDelete" confirmText="delete" usePortal>
    <CircleIcon icon={Close} />
  </PromptClick>
);

export default DeleteRenderer;
